import { ApiBaseService, ApiV2Service } from './api.base.service';
import {IdResponse, Interface, InterfaceField, SuccessResponse, Unit} from '@/types';

export class InterfaceService {
  private api: ApiBaseService;

  constructor() {
    this.api = ApiV2Service;
  }

  public async getInterfaces(): Promise<Interface[]> {
    return this.api.get(`admin/interfaces`);
  }

  public async getInterfaceById(id: number): Promise<Interface> {
    return this.api.get(`admin/interfaces/${id}`);
  }

  public async createInterface(body: Partial<Interface>): Promise<IdResponse> {
    return this.api.post(`admin/interfaces`, body);
  }

  public async updateInterface(id: number, body: Partial<Interface>): Promise<IdResponse> {
    return this.api.put(`admin/interfaces/${id}`, body);
  }

  public async deleteInterface(id: number): Promise<SuccessResponse> {
    return this.api.delete(`admin/interfaces/${id}`);
  }

  public async createInterfaceField(interfaceId: number, body: Partial<InterfaceField>): Promise<IdResponse> {
    return this.api.post(`admin/interfaces/${interfaceId}/fields`, body);
  }

  public async updateInterfaceField(interfaceId: number, fieldId: number, body: Partial<InterfaceField>): Promise<IdResponse> {
    return this.api.put(`admin/interfaces/${interfaceId}/fields/${fieldId}`, body);
  }

  public async deleteInterfaceField(interfaceId: number, fieldId: number ): Promise<SuccessResponse> {
    return this.api.delete(`admin/interfaces/${interfaceId}/fields/${fieldId}`);
  }

  public async getUnits(): Promise<Unit[]> {
    return this.api.get(`units`);
  }
}

export default new InterfaceService();
